import {
  createContext,
  useContext,
  type ComponentType,
  type ReactNode,
} from "react";

export interface AppShellSidebarUtilitiesProps {
  className?: string;
}

export interface AppShellTopbarActionsProps {
  className?: string;
}

export interface AppShellSlots {
  SidebarUtilities?: ComponentType<AppShellSidebarUtilitiesProps>;
  TopbarActions?: ReactNode;
}

const AppShellSlotsContext = createContext<AppShellSlots>({});

interface AppShellSlotsProviderProps {
  children: ReactNode;
  slots: AppShellSlots;
}

export const AppShellSlotsProvider = ({
  children,
  slots,
}: AppShellSlotsProviderProps) => (
  <AppShellSlotsContext.Provider value={slots}>
    {children}
  </AppShellSlotsContext.Provider>
);

export const useAppShellSlots = () => useContext(AppShellSlotsContext);
